import React, { useState } from "react";
import {
  Dialog, DialogActions, DialogContent, DialogContentText, Box
} from '@mui/material';
import sendRequest from '../utils/sendRequest';
import { MenuButton, CancelButton, SubmitButton } from "../styled/CustomButtons";
import { CustomDialogTitle } from "../styled/DialogTitles";

export default function ResumeReceivingDialog({ po_doc_id, poName, addSnackbar, fetchPoDetails }) {
  const [openResume, setOpenResume] = useState(false);
  const [loadingResume, setLoadingResume] = useState(false);

  const handleOpenResume = () => {
    setOpenResume(true);
  };

  const handleCloseResume = () => {
    if (!loadingResume) {
        setOpenResume(false);
    }
  };

  const resumeReceiving = async () => {
    setLoadingResume(true);
    try {
        let response = await sendRequest(
            `purchase-orders/resume-receiving?po_doc_id=${po_doc_id}`
        );
        addSnackbar(response.message);
        handleCloseResume();
        fetchPoDetails();
    } catch (error) {
        addSnackbar(error.message, false);
    } finally {
        setLoadingResume(false);
    }
  }

  return (
    <Box>
      <MenuButton onClick={handleOpenResume}  sx={{ width: '168px'}} color="warning">Resume Receiving</MenuButton>
      <Dialog
        open={openResume}
        onClose={handleCloseResume}
        disableEscapeKeyDown={loadingResume}
        PaperProps={{
          component: 'form',
          onSubmit: event => {
            event.preventDefault();
            resumeReceiving();
          },
          autoComplete: 'off',
        }}
      >
        <CustomDialogTitle
          header={"Resume Receiving"}
          poName={poName}
        />
        <DialogContent>
          <DialogContentText>Are you sure you want to resume receiving?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={handleCloseResume} disabled={loadingResume}>Cancel</CancelButton>
          <SubmitButton
            showSpinner={loadingResume}
            text={"Submit"}
            type="submit"
          />
        </DialogActions>
      </Dialog>
    </Box>
  )
}